import type { ButtonHTMLAttributes } from 'react'
import styles from './fields.module.css'

/**
 * Button Rango DS (LG 64px, raio 16px, sentence case) para a área da conta.
 */
export function Button({
  variant = 'primary',
  tone = 'default',
  loading = false,
  className,
  disabled,
  children,
  type = 'button',
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'link'
  /** `danger` = ação destrutiva (ex.: encerrar sessões), na cor de feedback negativo. */
  tone?: 'default' | 'danger'
  loading?: boolean
}) {
  const variantClass =
    variant === 'link'
      ? styles.linkButton
      : variant === 'secondary'
        ? styles.secondaryButton
        : styles.primaryButton
  return (
    <button
      type={type}
      className={[variantClass, className].filter(Boolean).join(' ')}
      data-tone={tone === 'danger' ? 'danger' : undefined}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {children}
    </button>
  )
}
